import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../services/api/axios.config';
import { notify } from '../utils/methods/notification';

const initialState = {
    preScreeningList: [],
};


export const getPreScreeningUserList = createAsyncThunk(
    'feasibility/getPreScreeningUserList',
    async (data, { rejectWithValue }) => {
        try {
            const response = await api.post('/pre-screening-user-list', data);
            // notify.success(response.data.message);
            return response.data;
        } catch (error) {
            notify.error(error ?? error.response.message);
            return rejectWithValue(error.response ? error.response.data : error.message);
        }
    }
);

export const updateFeasibility = createAsyncThunk(
    'feasibility/updateFeasibility',
    async (data, { rejectWithValue }) => {
        try {
            let id = data?.id
            delete data?.id
            const response = await api.patch(`/mark-feasibility/${id}`, data);
            notify.success(response.data.message);
            return response.data;
        } catch (error) {
            notify.error(error ?? error.response.message);
            return rejectWithValue(error.response ? error.response.data : error.message);
        }
    }
);

export const updateScheduleApheresis = createAsyncThunk(
    'feasibility/updateScheduleApheresis',
    async (data, { rejectWithValue }) => {
        try {
            let id = data?.id
            delete data?.id
            const response = await api.patch(`/update-schedule-apheresis/${id}`, data);
            notify.success(response.data.message);
            return response.data;
        } catch (error) {
            notify.error(error ?? error.response.message);
            return rejectWithValue(error.response ? error.response.data : error.message);
        }
    }
);

export const getApheresisRequestList = createAsyncThunk(
    'feasibility/getApheresisRequestList',
    async (data, { rejectWithValue }) => {
        try {
            const response = await api.post('/apheresis-request-list', data);
            // notify.success(response.data.message);
            return response.data;
        } catch (error) {
            notify.error(error ?? error.response.message);
            return rejectWithValue(error.response ? error.response.data : error.message);
        }
    }
);


const feasibilitySlice = createSlice({
    name: 'feasibility',
    initialState,
    reducers: {
        // clearPhaseList(state) {
        //     state.allPhaseList = []
        // },
        // enableAddModal(state) {
        //     state.addModal = true
        // },
        // disableAddModal(state) {
        //     state.addModal = false
        // },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getPreScreeningUserList.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getPreScreeningUserList.fulfilled, (state, action) => {
                state.isLoading = false;
                state.preScreeningList = action.payload.data
            })
            .addCase(getPreScreeningUserList.rejected, (state) => {
                state.isLoading = false;
            });

        builder
            .addCase(updateFeasibility.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(updateFeasibility.fulfilled, (state) => {
                state.isLoading = false;
            })
            .addCase(updateFeasibility.rejected, (state) => {
                state.isLoading = false;
            });

        builder
            .addCase(getApheresisRequestList.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getApheresisRequestList.fulfilled, (state, action) => {
                state.isLoading = false;
                state.apheresisRequestList = action.payload.data
            })
            .addCase(getApheresisRequestList.rejected, (state) => {
                state.isLoading = false;
            });
    },
});

export const selectBmrPreScreening = (state) => state.feasibility.preScreeningList;
export const apheresisRequestList = (state) => state.feasibility.apheresisRequestList;

export default feasibilitySlice.reducer;
